/* eslint-disable import/no-anonymous-default-export */
import Auth from './AuthReducer';
import Crud from './CRUDReducer';

export default {
  Auth,
  Crud
};
